import { render } from "./AccountantDashboard.vue?vue&type=template&id=445c6798&scoped=true"
import script from "./AccountantDashboard.vue?vue&type=script&lang=js"
export * from "./AccountantDashboard.vue?vue&type=script&lang=js"

import "./AccountantDashboard.vue?vue&type=style&index=0&id=445c6798&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445c6798"]])

export default __exports__